import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseCtl, ServiceLocatorService } from '@ncs/ncs-lib';

Chart.register(...registerables);
import html2canvas from 'html2canvas';
import * as html2pdf from 'html2pdf.js';
import jsPDF from 'jspdf';
import { Chart, registerables } from 'chart.js';
import { SidebarEvent } from '../SidebarEvent';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent extends BaseCtl {
    @ViewChild('content', { static: false }) content!: ElementRef;
  
    private orgId: number = 0;
    public sidebar: any = '';
    constructor(
      public override locator: ServiceLocatorService,
      public override route: ActivatedRoute,
      private cdRef: ChangeDetectorRef
     
    ) {
      super('', locator, route);
      let _self = this;

      this.sidebar = new SidebarEvent();
      locator.config.getProperty('endpoint.auth').then((property: string) => {
        _self.initApiEndpoint(property);
      });
      }
  
    override ngOnInit(): void {

      this.sidebar.initializeSidebar();
      this.locator.config
        .getProperty('endpoint.auth')
        .then((property: string) => {
      this.getuserform();
        });

    this.getAppSizeInfo();
     this.getDashboardReports();
    }
  
    override populateForm(form: any, data: any) {
      form.id = data.id;
      form.key = data.key;
      form.value = data.value;
      form.createdBy = data.createdBy;
      form.createdDatetime = data.createdDatetime;
      form.modifiedBy = data.modifiedBy;
      form.modifiedDatetime = data.modifiedDatetime;
      form.expiredAuthKey = data.expiredAuthKey;
      form.startDate = data.startDate;
      form.endDate = data.endDate;
    }
  
  public appInfoList: any = [];

  public getAppSizeInfo() {
    //alert('call app info');
    let _self = this;
    this.locator.config
      .getProperty('endpoint.dashboard')
      .then((property: string) => {
        let url = property + '/info';
        _self.locator.http.get(url, function (res: any, error: boolean) {
          if (error) {
            alert('Server Error:' + error);
            return;
          }
          _self.appInfoList = res.result['data'];
        });
      });
  }

    public formList: any = [];
  applicationname: any;
    /**
     * Get list of all dashboard showing
     * @param callback
     */
   async getuserform(callback?: any) {
      var _self = this;
      let  keySuffix: any;
      let  appId: any;
      _self.form.searchError = false;
      _self.form.searchMessage = '';
  
      await _self.locator.config.getProperty("CONTEXT_PATH").then(async (property: string) => {
        keySuffix = property + "-";       
        appId = localStorage.getItem(keySuffix + 'appId');
      });
      
      let searchParams = {
        showDashboard: 1,
        applicationId:Number(appId)
      };
  
      _self.locator.config
        .getProperty('endpoint.ui.forms')
        .then((property: string) => {
          _self.initApiEndpoint(property);
          let url = property + '/search/' + _self.form.pageNo;
  
          _self.locator.http.post(
            url,
            searchParams,
            function (res: any, error: any) {
              if (error) {
                if (callback) {
                  callback(error);
                }
                return;
              }
  
              _self.form.searchError = !res.success;
              _self.form.searchMessage = res.result['message'];
  
              if (res.success) {
                _self.formList = res.result.data;
                 _self.applicationname = res.result.data?.[0]?.applicationName;
                //Check empty list
                if (_self.formList.length == 0) {
                  _self.form.message = 'No record found';
                  _self.form.error = true;
                }
  
                if (callback) {
                  callback();
                }
              }
  
              if (callback) {
                callback();
              }
          },
          );
        });
    }
  
     ngAfterViewInit() {
      // Force Angular to detect all changes and ensure content is loaded
      this.cdRef.detectChanges();
      window.addEventListener('resize', this.sidebar.handleResize);
    }
  
    /**
     * Download PDF HTML
     */
    downloadPDF() {
      // Options for PDF generation
      const element = this.content.nativeElement;
  
      const options = {
        margin: 0.5,
        filename: 'document_with_image.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: 'in', format: 'a3', orientation: 'portrait' },
      };
  
      // Wait for any dynamically loaded content (like images) to be fully loaded
      console.log(element);
  
      setTimeout(() => {
        html2pdf().from(element).set(options).save();
      }, 1000); // Adjust the delay if necessary
    }
  
    public captureScreen() {
      let downLoadSection = document.getElementById('pdfmake') as HTMLElement;

    // Use html2canvas to capture the DOM element
    html2canvas(downLoadSection, { scale: 2 }).then(function (canvas) {
        let HTML_Width = canvas.width;
        let HTML_Height = canvas.height;

        let top_left_margin = 15;
      let PDF_Width = 595.28; // A4 width in points
      let PDF_Height = 841.89; // A4 height in points
      let canvas_image_width = PDF_Width - top_left_margin * 2; // Adjust for margins
      let canvas_image_height = (HTML_Height / HTML_Width) * canvas_image_width;

      let totalPDFPages = Math.ceil(canvas_image_height / PDF_Height);

      // Convert canvas to image
      let imgData = canvas.toDataURL('image/png', 0.8);

      // Create a new jsPDF instance
        let pdf = new jsPDF('p', 'pt', [PDF_Width, PDF_Height]);

      // Load and add the header image
      const headerImage = new Image();
      headerImage.src = 'assets/images/cdblack.png'; // Path to the header image
      headerImage.onload = function () {
        // Loop through pages to create multi-page PDF
        for (let i = 0; i < totalPDFPages; i++) {
          let yOffset = -(PDF_Height * i);

          if (i !== 0) {
            pdf.addPage();
          }

          // Add header image at the top
          pdf.addImage(headerImage, 'PNG', 15, 10, 150, 75); // Larger header image dimensions

          // Add content image (captured DOM)
        pdf.addImage(
          imgData,
            'PNG',
          top_left_margin,
            80 + yOffset, // Position content below the larger header
          canvas_image_width,
            canvas_image_height,
        );

          // Add right-aligned footer text
          const pageHeight = pdf.internal.pageSize.height; // Height of the page
          const footerText = 'Powered by Powered by NCS^ NO-CODE Platform Pvt. Ltd.';
          pdf.setFontSize(10); // Set font size explicitly
          const fontSize = 10; // Font size used
          const textWidth =
            (pdf.getStringUnitWidth(footerText) * fontSize) /
            pdf.internal.scaleFactor;
          pdf.text(
            footerText, // Footer text
            PDF_Width - textWidth - top_left_margin, // Align text to the right
            pageHeight - 10, // Position footer 10 units from the bottom
          );
        }

        // Save the PDF
        pdf.save('Cuickdev.pdf');
      };
    });
  }

  trackByForm(index: number, item: any) {
    return item?.id ?? index;
  }


 private readonly BATCH_SIZE = 3;    
 private readonly BATCH_DELAY = 150; 


getLoadDelay(index: number): number {
  const batchNumber = Math.floor(index / this.BATCH_SIZE);
  return batchNumber * this.BATCH_DELAY;
}

  public reportList: any[] = [];
  async getDashboardReports() {
  let _self = this;
    
   
    const reportsProperty = await _self.locator.config.getProperty('endpoint.reports');
    const url = reportsProperty + '/search/0';
    
    const contextPath = await _self.locator.config.getProperty("CONTEXT_PATH");
    const keySuffix = contextPath + "-";
    console.log(keySuffix);
    
    const appId = localStorage.getItem(keySuffix + 'appId');
    console.log("appId--", appId);
    
   
    const payload = {
      addOnDashboardReport: 1,
      applicationId: Number(appId)  
      };
    console.log(payload); 
    
    
    _self.locator.http.post(url, payload, function (res: any, error: any) {
      if (error || !res.success) return;
      _self.reportList = res.result.data || [];
    });
    }
  }
